import { useTranslation as use18nextTranslation } from 'react-i18next';

import { Translator } from '@Utils/translation';

export const useTranslations = () => {
  const { t } = use18nextTranslation();

  return t as Translator;
};
